export default "__VITE_ASSET__CiWcEtnQ__"